<div
  class="address-field-substitute"
  [formGroup]="substituteForm"
>
  <h4 class="with"><span>substitute</span></h4>
  <div class="replace-container">
    <label>
      <input type="text" placeholder="Empty string"
             [formControl]="substituteControl">
    </label>
  </div>
  <h4 class="with"><span>with</span></h4>
  <div class="replace-container">
    <label>
      <input type="text" placeholder="Empty string"
             [formControl]="replacementControl">

    </label>
  </div>

</div>
